import React, { memo } from 'react';
import clsx from 'clsx';

import { EditIcon } from 'components/icons/EditIcon';
import { TrashIcon } from 'components/icons/TrashIcon';
import { AddUserIcon } from 'components/icons/AddUserIcon';

interface IActionTimeline {
  hashId: string;
  itemType: string;
  handleEdit: (hashId: string) => void;
  handleSpeaker: () => void;
  onDelete: () => void;
  hasHighligtedText?: boolean;
}

function ActionTooltips({ hashId, itemType, handleEdit, handleSpeaker, onDelete, hasHighligtedText }: IActionTimeline) {
  const assignSpeaker = () => {
    console.log('assign speaker');
    handleSpeaker();
  };
  const handleDelete = () => {
    onDelete();
  };
  const onEdit = () => {
    handleEdit(hashId);
  };

  return (
    <div
      className={clsx(
        'cursor-pointer absolute right-2 -top-1 bg-white flex p-[2px] leading-none rounded-md shadow-default z-50 text-sm'
      )}
    >
      {(itemType === 'sentence' || itemType === 'chapter') && (
        <>
          {itemType === 'sentence' && (
            <div
              className="group w-8 h-8 flex items-center justify-center rounded bg-none hover:bg-iconColor hover:bg-opacity-5"
              onClick={assignSpeaker}
            >
              <AddUserIcon className="w-4 h-4 opacity-70 group-hover:opacity-100" />
            </div>
          )}
        </>
      )}

      {itemType === 'keyframe' ? (
        <>
          {hasHighligtedText && (
            <div
              className="group w-8 h-8 flex items-center justify-center rounded bg-none hover:bg-iconColor hover:bg-opacity-5"
              onClick={onEdit}
            >
              <EditIcon className="w-3 h-4 opacity-70 group-hover:opacity-100" />
            </div>
          )}
        </>
      ) : (
        <div
          className="group w-8 h-8 flex items-center justify-center rounded bg-none hover:bg-iconColor hover:bg-opacity-5"
          onClick={onEdit}
        >
          <EditIcon className="w-3 h-4 opacity-70 group-hover:opacity-100" />
        </div>
      )}
      <div
        className="group w-8 h-8 flex items-center justify-center rounded bg-none hover:bg-iconColor hover:bg-opacity-5"
        onClick={() => handleDelete()}
      >
        <TrashIcon className="w-4 h-4 fill-[#dd2c3c] opacity-70 group-hover:opacity-100" />
      </div>
    </div>
  );
}

export default memo(ActionTooltips);
